import React from 'react';
import PropTypes from 'prop-types';

export const Close = ({ width, height, ...props }) => (
  <svg
    data-icon='close'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M6.4 19 5 17.6l5.6-5.6L5 6.4 6.4 5l5.6 5.6L17.6 5 19 6.4 13.4 12l5.6 5.6-1.4 1.4-5.6-5.6L6.4 19Z'
    />
  </svg>
);

Close.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Close.defaultProps = {
  width: 24,
  height: 24,
};
